module.exports = __webpack_public_path__ + "static/media/tournament-builder-bg.3e7a4dc2.jpg";